module.exports = __webpack_public_path__ + "img/SM_olympisk.a992f93a.jpg";